import styled from 'styled-components';
import { BP_TABLET_MAX, BP_MOBILE_MAX } from '../../assets/styles/breakpoints';

export default styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  padding-bottom: 30px;
  max-width: 1080px;
  margin: 0 auto;
  @media (max-width: ${BP_TABLET_MAX}px) {
    max-width: 560px;
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    max-width: 100%;
  }
`;

export const SearchWrapSC = styled.div`
  width: 100%;
`;

export const FaqsBodySC = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-top: 60px;
  @media (max-width: ${BP_MOBILE_MAX}px) {
    padding-top: 32px;
  }
`;

export const FaqsHeadlineSC = styled.h2`
  font-size: 34px;
  font-weight: bold;
  width: 100%;
  margin-bottom: 0px;
`;
